import styled from '@emotion/styled';
import { IconButton } from '@material-ui/core';

const PrimaryIconButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.text.primary
}));

export default PrimaryIconButton;
